import { COREUI_DEVICE_ICON_MAPPING, ICON_MAPPING } from './icons'
import * as battery0 from '@/../images/device_icons/tem/battery0.svg'
import * as battery20 from '@/../images/device_icons/tem/battery20.svg'
import * as battery40 from '@/../images/device_icons/tem/battery40.svg'
import * as battery60 from '@/../images/device_icons/tem/battery60.svg'
import * as battery80 from '@/../images/device_icons/tem/battery80.svg'
import * as battery100 from '@/../images/device_icons/tem/battery100.svg'
import * as chp from '@/../images/device_icons/tem/chp.svg'
//import * as container from '@/../images/device_icons/tem/container.svg'
import * as coreuiDeviceIcons from '@/../images/device_icons/tem/coreui_device_icons'
import * as wallbox from '@/../images/device_icons/tem/wallbox.svg'
import * as fuelcell from '@/../images/device_icons/tem/fuelcell.svg'
//import * as generic from '@/../images/device_icons/tem/generic.svg'
import * as grid from '@/../images/device_icons/tem/grid.svg'
//import * as heatingelement from '@/../images/device_icons/tem/heatingelement.svg'
import * as heatpump from '@/../images/device_icons/tem/heatpump.svg'
import * as pv from '@/../images/device_icons/tem/pv.svg'
//import * as rest from '@/../images/device_icons/tem/rest.svg'
//import * as trafo from '@/../images/device_icons/tem/trafo.svg'
import * as user from '@/../images/device_icons/tem/user.svg'

const map = {
  battery: battery0,
  battery0,
  battery20,
  battery40,
  battery60,
  battery80,
  battery100,
  chp,
  //container,
  fuelcell,
  grid,
  //heatingelement,
  heatpump,
  pv,
  //rest,
  //trafo,
  user,
  wallbox
}

export function overwriteIcons() {
  Object.assign(ICON_MAPPING, map)
}

export function overwriteCoreuiDeviceIcons() {
  Object.assign(COREUI_DEVICE_ICON_MAPPING, coreuiDeviceIcons)
}
